import React from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { useNoticeReStock } from 'src/hooks/useNoticeReStock';
import type { Product } from 'src/models/product/schema';
import styles from './index.module.scss';

type Props = {
  product: Product;
  text: string;
};

export const NoticeButton: React.FC<Props> = ({ product, text }) => {
  const { showReStockRegisterModal } = useNoticeReStock(product);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    showReStockRegisterModal();
  };

  return (
    <button className={styles.noticeButton} onClick={handleClick} data-testid="product-item-notice-button">
      <NextImage src="/kaimono/images/products/notice.svg" width={20} height={20} alt={text} />
    </button>
  );
};
